import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login, isLoading, isAuthenticated, isDevMode } = useAuth();
  const [error, setError] = useState<string | null>(null);
  
  // Redirect if already authenticated (including dev mode)
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleMicrosoftLogin = async () => {
    setError(null);
    try {
      await login();
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Login failed';
      setError(message);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <svg
            className="mx-auto h-12 w-12 text-coveo-orange"
            viewBox="0 0 32 32"
            fill="currentColor"
          >
            <circle cx="16" cy="16" r="14" />
          </svg>
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Sign in to Demo Inventory
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Use your Coveo Microsoft account to access the demo catalog
          </p>
          {isDevMode && (
            <p className="mt-2 text-sm text-yellow-600 bg-yellow-50 p-2 rounded">
              🔧 Dev Mode: Redirecting to the app...
            </p>
          )}
        </div>

        <div className="mt-8 space-y-6">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm">
              {error}
            </div>
          )}

          <div>
            <button
              onClick={handleMicrosoftLogin}
              disabled={isLoading}
              className="w-full flex items-center justify-center gap-3 btn-primary py-3 bg-[#2F2F2F] hover:bg-[#1F1F1F] text-white"
            >
              {/* Microsoft Logo */}
              <svg className="h-5 w-5" viewBox="0 0 21 21" fill="none">
                <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
                <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
                <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
                <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
              </svg>
              {isLoading ? 'Signing in...' : 'Sign in with Microsoft'}
            </button>
          </div>

          <div className="text-center text-sm text-gray-500">
            <p>Use your existing Coveo Microsoft credentials.</p>
            <p className="mt-1">No registration required.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
